import type { ReactNode } from "react";
import { useFetchClientQuery } from "~/lib/graphql";
import { isBot } from "~/util/is-bot";
import { isDatadog } from "~/util/is-datadog";

type Props = {
  children: ReactNode;
};

const isTest = !!process.env.TEST;

export const ForeignRedirectWrapper = (props: Props) => {
  const { children } = props;
  const { data, loading } = useFetchClientQuery();

  if (loading || data === undefined) return null;

  if (data.client.isForeignAccess && !isBot() && !isDatadog() && !isTest) {
    location.href = process.env.NEXT_PUBLIC_NOT_AVAILABLE_REGION;
    return null;
  }

  return <>{children}</>;
};
